/**
 * This is a temporary fix until https://github.com/hotwired/turbo/issues/624
 * is resolved.
 *
 * To remove, replace all "autoscroll-custom" attributes with "autoscroll".
 */
export default class CustomAutoscroll {
    constructor() {
        // forms and post events
        document.addEventListener('turbo:submit-end', this._submitEnd);

        // links (non-post events)
        document.addEventListener('turbo:before-render', this._beforeRender);
    }

    _submitEnd = (event) => {
        const form   = event.target;
        const target = form.dataset.turboFrame;

        if (!target) {
            return;
        }

        setTimeout(() => this._scrollToFrame(target), 100)
    };

    _beforeRender = (event) => {
        const id = event.target.id;

        if (id && event.target.tagName !== 'FORM') {
            setTimeout(() => {
                this._scrollToFrame(id);
            }, 10);

        } else if (event.target.tagName === 'HTML') {
            this._scrollToTop();
        }
    };

    _scrollToFrame(id) {
        const frame = document.getElementById(id);

        if (frame && frame.getAttribute('autoscroll-custom')) {
            const block    = frame.getAttribute('data-autoscroll-block') || 'end';
            const behavior = frame.getAttribute('data-autoscroll-behavior') || 'instant';

            frame.scrollIntoView({
                block,
                behavior,
            });
        }
    }

    _scrollToTop() {
        window.scrollTo({
            top:      0,
            left:     0,
            behavior: 'instant',
        });
    };
}
